import React from "react"
import { useScrollReveal, trackStyles } from "../utils"

export function TracksBlock({ programme, styleMap, hoveredTrack, setHoveredTrack }) {
  const ref = useScrollReveal()
  const cards = (programme.tracks || []).filter(t => t.card !== false)

  return (
    <div ref={ref} style={{ padding: "80px 60px 0", boxSizing: "border-box" }}>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", paddingTop: 60 }}>
        <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: "#fff", margin: "0 0 48px" }}>
          {cards.length === 1 ? "Track" : `${cards.length} tracks`}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: `repeat(${Math.min(cards.length, 2)}, 1fr)`, gap: 2, maxWidth: 1200 }}>
          {cards.map((track, idx) => {
            const styleKey = styleMap[track.id] || "neutral"
            const ts = trackStyles[styleKey]
            const isPrimary = idx === 0
            const border = isPrimary
              ? `3px solid ${ts.color}`
              : `3px ${ts.borderStyle} rgba(255,64,0,${ts.opacity})`
            const padLeft  = idx === 0 ? 0   : 60
            const padRight = idx === 0 ? 60  : 0

            return (
              <div
                key={track.id}
                onMouseEnter={() => setHoveredTrack(styleKey)}
                onMouseLeave={() => setHoveredTrack(null)}
                style={{
                  borderTop: border,
                  padding: `36px ${padRight}px 36px ${padLeft}px`,
                  cursor: "default",
                  transition: "opacity 0.2s ease",
                  opacity: hoveredTrack && hoveredTrack !== styleKey ? 0.3 : 1,
                }}
              >
                <span style={{ display: "inline-block", fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", color: "#FF4000", marginBottom: 16 }}>
                  {track.label}
                </span>
                <h2 style={{ fontFamily: "Instrument Serif, Georgia, serif", fontSize: "clamp(24px, 2.8vw, 40px)", fontWeight: 400, lineHeight: 1.1, letterSpacing: "-0.02em", color: "#fff", margin: "0 0 20px" }}>
                  {track.name}
                </h2>
                {track.description && (
                  <p style={{ fontSize: 15, lineHeight: 1.65, color: "#fff", margin: "0 0 16px" }}>
                    {track.description}
                  </p>
                )}
                {track.audience && (
                  <p style={{ fontSize: 13, color: "#fff", margin: 0 }}>
                    <strong style={{ fontWeight: 600 }}>Audience:</strong> {track.audience}.
                  </p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
